// eslint-disable-next-line import/prefer-default-export
export function setUnreadCount (context, value) {
    context.setUnreadCount(value);
}
